var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"boost-ended-icon",style:({ '--size': _vm.size + 'px' }),attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"art"},[_c('span',{staticClass:"wave"}),_c('span',{staticClass:"wave second"}),_c('BaseIcon',{attrs:{"icon-file":"icons/tabbar/boost-ended","width":_vm.size,"height":_vm.size}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }